import {Button, Flex, Typography, theme} from 'antd';
import React from 'react';
import PropTypes from 'prop-types';
import {useCSContext} from 'Context/ContentStackContext';
import DialogWrapper from './DialogWrapper';
import styles from './styles';
import {GIFTING} from '../../giftingConstants';

const GiftDialogSuccess = ({openSuccessDialog, setOpenSuccessDialog, customerEmail}) => {
  const {artifacts} = useCSContext();
  const {token}: any = theme.useToken();

  return (
    <DialogWrapper closeDialogMethod={setOpenSuccessDialog} open={openSuccessDialog}>
      <Flex
        vertical
        gap={12}
        style={{
          ...styles.container,
          background: token.colorSuccessBg,
          borderRadius: token.borderRadiusLG,
          padding: 24,
        }}>
        <img src={artifacts.gift_opened_icon} alt="" />
        <Typography.Title level={4} style={{margin: 0, color: token.colorSuccess}}>
          {GIFTING.gifting_dialog_success.heading}
        </Typography.Title>
        <Typography.Text style={{textAlign: 'center', color: token.colorSuccess}}>
          {GIFTING.gifting_dialog_success.subtitle} {customerEmail}.
        </Typography.Text>
      </Flex>
      <div style={styles.buttonBox}>
        <Button onClick={() => setOpenSuccessDialog(false)} style={styles.button}>
          {GIFTING.gifting_dialog_success.button_text}
        </Button>
      </div>
    </DialogWrapper>
  );
};

GiftDialogSuccess.propTypes = {
  openSuccessDialog: PropTypes.bool,
  setOpenSuccessDialog: PropTypes.func,
  customerEmail: PropTypes.any,
};

export default GiftDialogSuccess;
